import React from "react";
import { Col, Row } from "react-bootstrap";
import AboutThisImport from "./AboutThisImport";
import OverviewYourImport from "./OverviewYourImport";

export default function Verifying() {
  return (
    <div>
      {" "}
      <Row className="mb-5 mt-3 m-5">
        <Col xs={12} lg={6} className="pe-5 border-end">
          <AboutThisImport />
        </Col>
        <Col xs={12} lg={6} className="pe-5 border-end">
          <OverviewYourImport />
        </Col>
      </Row>
    </div>
  );
}
